import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  setLoading,
  fetchPromotionsSuccess,
  fetchPromotionsFailure,
  saveFilters,
  setSubmitting,
  setCurrentPromotion,
  clearData,
} = reducer.actions

export const fetchPromotions = createAction('surpriseBox/fetchPromotions')
export const fetchPromotion = createAction('surpriseBox/fetchPromotion')
export const createPromotion = createAction('surpriseBox/createPromotion')
export const updatePromotion = createAction('surpriseBox/updatePromotion')
export const activatePromotion = createAction('surpriseBox/activatePromotion')
export const deactivatePromotion = createAction('surpriseBox/deactivatePromotion')
export const cancelPromotion = createAction('surpriseBox/cancelPromotion')
